// Semantic color palette. Light + dark variants.
// Both MUI and React Native Paper themes are built from these raw values.
//
// Neutrals are layered — app bg is subtly off-white so white cards float.
export const lightColors = {
    primary: '#0D9488',
    primaryHover: '#0F766E',
    primarySoft: '#F0FDFA',
    onPrimary: '#FFFFFF',
    secondary: '#6E6E73',
    onSecondary: '#FFFFFF',
    success: '#1F8B4C',
    onSuccess: '#FFFFFF',
    successSoft: '#ECFDF5',
    warning: '#B45309',
    onWarning: '#FFFFFF',
    warningSoft: '#FFFBEB',
    danger: '#DC2626',
    onDanger: '#FFFFFF',
    dangerSoft: '#FEF2F2',
    info: '#0369A1',
    onInfo: '#FFFFFF',
    infoSoft: '#F0F9FF',
    background: {
        default: '#F5F5F7', // app bg — subtle off-white (floats white cards)
        paper: '#FFFFFF', // cards, dialogs, menus
        elevated: '#FFFFFF',
        subtle: '#FAFAFA', // faint sections inside cards
    },
    text: {
        primary: '#1D1D1F', // near-black, high contrast
        secondary: '#6E6E73',
        tertiary: '#8E8E93',
        disabled: '#C7C7CC',
        inverse: '#FFFFFF',
    },
    divider: 'rgba(0, 0, 0, 0.06)', // hairline
    border: 'rgba(0, 0, 0, 0.08)',
};
export const darkColors = {
    primary: '#2DD4BF',
    primaryHover: '#5EEAD4',
    primarySoft: 'rgba(45, 212, 191, 0.12)',
    onPrimary: '#042F2E',
    secondary: '#8E8E93',
    onSecondary: '#000000',
    success: '#34D399',
    onSuccess: '#022C22',
    successSoft: 'rgba(52, 211, 153, 0.12)',
    warning: '#FBBF24',
    onWarning: '#1C1917',
    warningSoft: 'rgba(251, 191, 36, 0.12)',
    danger: '#F87171',
    onDanger: '#450A0A',
    dangerSoft: 'rgba(248, 113, 113, 0.12)',
    info: '#60A5FA',
    onInfo: '#0C4A6E',
    infoSoft: 'rgba(96, 165, 250, 0.12)',
    background: {
        default: '#0E1014', // main app bg — dark with a hint of blue
        paper: '#17181C', // cards
        elevated: '#1E2026',
        subtle: '#141821', // sidebar — distinctly darker/navy
    },
    text: {
        primary: '#F5F5F7',
        secondary: '#8E8E93',
        tertiary: '#636366',
        disabled: '#48484A',
        inverse: '#1D1D1F',
    },
    divider: 'rgba(255, 255, 255, 0.08)',
    border: 'rgba(255, 255, 255, 0.12)',
};
//# sourceMappingURL=colors.js.map